

import ButtonsErrorPage, { ButtonsErrorPageProps } from "ui/components/ButtonsErrorPage"

export type BoundaryProps = ButtonsErrorPageProps

export default function Boundary(props: BoundaryProps) {
    return (
        <ButtonsErrorPage error={props.error} resetErrorBoundary={props.resetErrorBoundary} />
    )
}
